<template>
    <div class="navigation-bar">
        <ul>
            <li :class="{ active: $route.path === '/HomePage' }"><router-link to="/HomePage">首页</router-link></li>
            <li :class="{ active: $route.path === '/CreateForm' }"><router-link to="/CreateForm">创建打单表</router-link>
            </li>
            <li :class="{ active: $route.path === '/ManageForm' }"><router-link to="/ManageForm">管理打单表</router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "NavigationBar",
    };
</script>

<style scoped>
    .navigation-bar {
        width: 220px;
        height: 100%;
        background-color: #3f4f67;
        border-radius: 8px;
    }

    li {
        list-style: none;
        height: 60px;
    }
    a {
        display: flex;
        align-items: center;
        justify-content: left;
        width: 100%;
        height: 100%;
        padding-left: 40px;
        font-size: 22px;
        font-weight: bold;
        text-decoration: none;
        letter-spacing: 0.2rem;
        color: #c8c8c9;
    }
    .active {
        background-color: #20334e;
    }

    .active a {
        color: #fff;
    }
</style>